<kendo-dialog
  *ngIf="isOpen"
  [title]="title"
  [minWidth]="320"
  [width]="640"
  (close)="closed.emit()"
>
  <div class="ved-body">
    <p class="ved-intro" *ngIf="intro">{{ intro }}</p>

    <ng-container *ngIf="hasGroups; else plain">
      <section class="ved-group" *ngFor="let group of groups">
        <h4 class="ved-group-heading">{{ group.heading }}</h4>
        <ul class="ved-list">
          <li *ngFor="let item of group.items">{{ item }}</li>
        </ul>
      </section>
    </ng-container>

    <ng-template #plain>
      <p class="ved-message" *ngIf="message && allowHtml" [innerHTML]="message"></p>
      <p class="ved-message" *ngIf="message && !allowHtml">{{ message }}</p>
    </ng-template>
  </div>

  <kendo-dialog-actions>
    <button class="btn btn-warning btn-sm" (click)="closed.emit()">{{ closeLabel }}</button>
  </kendo-dialog-actions>
</kendo-dialog>
